@switch (activeOption) {
    @case (options.OWN_PROPERTY) {
        <own-property-part></own-property-part>
    }
    @case (options.OWN_MONEY) {
        <own-money-part></own-money-part>
    }
    @case (options.SUMMARY) {
        <own-property-part></own-property-part>
        <hr />

        <own-money-part></own-money-part>
        <hr />
    }
}
